import { createContext } from "react";
import type { WsStatus } from "@/lib/notification-ws";
import type { Notification } from "@/types/notification";

export interface NotificationContextType {
  wsStatus: WsStatus;
  unreadCount: number;
  realtimeQueue: Notification[];
  setUnreadCount: (count: number) => void;
  decrementUnread: (n?: number) => void;
  clearRealtimeQueue: () => void;
}

export const NotificationContext = createContext<NotificationContextType | null>(null);
